// src/modules/app-views/_apps/appmulti/operators/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

import entitiesService from 'services/entitiesService';
import { returnOnlyNumbers } from 'utils/helpers';
import operatorsService from 'modules/app-views/_apps/appmulti/operators/service';

const decorateRequest = ctx => {
  const { data, allValues } = ctx;

  if (!data) return data;

  // Start with entities standard decorator
  const transformed = entitiesService.decorator(data, allValues, ctx) || { ...data };

  // Generate uniqueKey from CNPJ (only numbers)
  const cnpjValue = allValues?.cnpj?.value || data?.cnpj?.value;
  if (cnpjValue) {
    transformed.uniqueKey = returnOnlyNumbers(cnpjValue);
  }

  // Manage exchange rate history
  const newRate = allValues?.parameters?.__exchangeRate;
  const newCurrency = allValues?.parameters?.__exchangeRateSuffix;
  const currentExchanges = allValues?.parameters?.exchanges || [];

  if (newRate && newCurrency) {
    const updatedExchanges = operatorsService.buildExchangeHistory(
      currentExchanges,
      newRate,
      newCurrency
    );
    if (!transformed.parameters) transformed.parameters = {};
    transformed.parameters.exchanges = updatedExchanges;
  }

  return transformed;
};

export default decorateRequest;
